module.exports = __webpack_public_path__ + "static/media/play-circle.cfb37aaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/play-circle.svg
// module id = 579
// module chunks = 0